import React from "react";
import KeyboardView from "./KeyboardView";
import ControlsView from "./ControlsView";
import Container from "./Container";
import Help from "./Help";
import KeyHint from "./KeyHint";

function App() {
  return (
    <div>
      <Container>
        <ControlsView />
        <KeyboardView />
      </Container>
      <Help>
        <p>
          <KeyHint>1</KeyHint> to <KeyHint>8</KeyHint> -{" "}
          <span>Select instrument</span>
        </p>
        <p>
          <KeyHint>a</KeyHint> to <KeyHint>\</KeyHint> - <span>Play notes</span>
        </p>
        <p>
          <KeyHint>⇧</KeyHint> - <span>Octave up</span>
        </p>
      </Help>
    </div>
  );
}

export default App;
